import Vue from 'vue'
import VuetableFieldCheckbox from 'vuetable-2/src/components/VuetableFieldCheckbox.vue'
import numeral from 'numeral'
import i18n from '@/plugins/i18n';

function formatNumber(value) {
    return numeral(value).format("0,0");
}

function formatNumberDigit(value) {
    return numeral(value).format("0,0.00");
}

export default [
    {
        id: 'name',
        name: 'name',
        title: i18n.t('Product Detail'),
        filterable: false,
        togglable: true,
    },
    {
        id: 'number_order',
        name: 'sum_order_quantity',
        title: i18n.t('_Shipping.Number of Orders'),
        sortField: "sum_order_quantity",
        filterable: true,
        togglable: true,
        formatter: (data) => {
            return formatNumber(data);
        }
    },
    {
        id: 'number_product',
        name: 'sum_product_order_quantity',
        title: i18n.t('Number of Products'),
        sortField: "sum_product_order_quantity",
        filterable: true,
        togglable: true,
        formatter: (data) => {
            return formatNumber(data);
        }
    },
    {
        id: 'sales',
        name: 'sum_product_total',
        title: i18n.t('Sales'),
        sortField: "sum_product_total",
        filterable: true,
        togglable: true,
        formatter: (data) => {
            return formatNumberDigit(data);
        }
    }
];



// WEBPACK FOOTER //
// ./src/components/tenancy/admin/report/assets/js/bestseller_fields.js